import React, { useState } from 'react'
import "../Comments/Comments.css"
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import { format } from 'date-fns';

const Comments = ({cmt}) => {
    const [booleonLike,setBooleonLike] =useState(false)
    const [likeCount,setLikeCount] =useState(cmt.likes)

  return (
    <div className="overAllCommentList">
        <div className="commentList">
            <div className='commentList1'>
                <div className="commentHead">
                    <div><img src={cmt.commenter_profile_pic} /></div>
                    <p><span>{cmt.commenter_name}:&nbsp;</span>{cmt.comment_content}</p>
                </div>

                <div className="commentFooter">
                    <p>{format(new Date(cmt.create_at), 'dd-MM-yyyy HH:mm:ss')}</p>
                    {/* <p>{booleonLike ? likeCount +1 : likeCount} likes</p> */}
                </div>
            </div>

        {/* <div className="commentList2">
            <p 
            className='cp'
            onClick={()=>setBooleonLike(!booleonLike)}
            style={{cursor:"pointer"}}
            >
                {booleonLike ? <FavoriteRoundedIcon /> : <FavoriteBorderOutlinedIcon />}
            </p>
        </div> */}
    </div>
    </div>
    
  )
}

export default Comments